import { TextComponent } from '../../../../uiComponent/TextComponent/TextComponent';

export const MTPRTipComponent = () => (
  <TextComponent>
    Please review patient's vital data in the past 30 days,
    adjust clinical goals if necessary, and write a review note.
  </TextComponent>
);
